export class DbConstants {
  private static store: Record<string, any> = {};

  public static set(name: string, value: any): void {
    this.store[name] = value;
  }

  public static get(name: string): any {
    return this.store[name];
  }

  public static setAll(data: Record<string, any>): void {
    this.store = { ...(data || {}) };
  }

  public static parse(data: Record<string, any>): void {
    this.setAll(data);
  }

  public static toJson(): Record<string, any> {
    return { ...this.store };
  }
}
